// extracted by mini-css-extract-plugin
export var body = "_gc-5";
export var closeButton = "_gc-f";
export var container = "_gc-1";
export var content = "_gc-2";
export var cta = "_gc-c";
export var ctaLabel = "_gc-b";
export var eyebrow = "_gc-3";
export var howTo = "_gc-6";
export var image = "_gc-e";
export var modal = "_gc-0";
export var socialButton = "_gc-d";
export var stepCard = "_gc-8";
export var stepLabel = "_gc-a";
export var stepNumber = "_gc-9";
export var steps = "_gc-7";
export var title = "_gc-4";